import Vue from "vue";
import Router from "vue-router";

import App from "@/App.vue";
import Home from "@/components/Home.vue";

// This lazily loads linked to components
const AtlassianLanding = () => import("@/components/AtlassianLanding.vue").then(m => m);

const Contact = () => import("@/components/Contact.vue").then(m => m);
const About = () => import("@/components/About.vue").then(m => m);

const LegalNotice = () => import("@/components/LegalNotice.vue").then(m => m);
const DataProtection = () =>
  import("@/components/DataProtection.vue").then(m => m);
const TermsAndConditions = () =>
  import("@/components/TermsAndConditions.vue").then(m => m);

const Overview = () =>
  import("@/components/consulting/Overview.vue").then(m => m);
const Software = () =>
  import("@/components/consulting/Software.vue").then(m => m);
const Knowledge = () =>
  import("@/components/consulting/Knowledge.vue").then(m => m);
const Confluence = () =>
  import("@/components/consulting/Confluence.vue").then(m => m);
const Digitalization = () =>
  import("@/components/consulting/Digitalization.vue").then(m => m);
const Jira = () => import("@/components/consulting/Jira.vue").then(m => m);

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "detect-lang",
    },

    {
      path: "/:lang",
      name: "home",
      component: Home
    },
    {
    path: "/:lang/atlassian",
      name: "atlassian-landing",
      component: AtlassianLanding
    },

    { path: "/:lang/contact", name: "contact", component: Contact },
    { path: "/:lang/about", name: "about", component: About },

    { path: "/:lang/legal", name: "legal", component: LegalNotice },
    { path: "/:lang/privacy", name: "privacy", component: DataProtection },
    { path: "/:lang/terms", name: "terms", component: TermsAndConditions },

    {
      path: "/:lang/consulting/overview",
      name: "overview",
      component: Overview
    },
    {
      path: "/:lang/consulting/software",
      name: "software",
      component: Software
    },
    {
      path: "/:lang/consulting/knowledge",
      name: "knowledge",
      component: Knowledge
    },
    {
      path: "/:lang/consulting/confluence",
      name: "confluence",
      component: Confluence
    },
    {
      path: "/:lang/consulting/digitalization",
      name: "digitalization",
      component: Digitalization
    },
    { path: "/:lang/consulting/jira", name: "jira", component: Jira }
  ]
});
